export const APP_STORE_URL = 'https://apps.apple.com/app/leka-learning/id6758303395';
export const APP_STORE_ID = '6758303395';
export const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=app.leka.language';
export const ANDROID_COMING_SOON = false;
